export default __webpack_public_path__ + "static/media/web.db409c12.jpg";